module.exports = __webpack_public_path__ + "img/ИФ-1(А)-033-m.8f4b06d0.png";